import styled, { keyframes } from "styled-components";

const bounce = keyframes`
    0% {
        transform: translateY(-3px);
    }
    15% {
        transform: translateY(-3px);
    }
    45% {
        transform: translateY(0px);
    }
    55% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(-3px);
    }
`;

const LandingButton = styled.div`
    animation: ${bounce} infinite 2.5s linear;
    cursor: pointer;
    max-width: 100%;
    padding: 15px;
    position: relative;
    z-index: 10;
`;

LandingButton.displayName = "LandingButton";

export default LandingButton;
